import styled, { css, keyframes } from 'styled-components'

import BG_GRAY from './assets/bg-gray.inline.svg'
import SMALL_HIGHLIGHT_SHIELD from './assets/shield-highlight.inline.svg'
import SHIELD from './assets/shield.inline.svg'
import SMALL_SHIELD from './assets/small-shield.inline.svg'
import WHITE_SHIELD from './assets/white-shield.inline.svg'

import type { ClassNameProps } from '@root/shared/react'

export const CreateWalletGraphic = ({ className }: ClassNameProps) => {
  return (
    <Root className={className}>
      <Bg />
      <ShieldAnimated />
      <WhiteHighlightAnimated />
      <WhiteShieldAnimated />
      <SmallShieldAnimated />
    </Root>
  )
}

const contentShow = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`

const url = (imageUrl: string) => `url("${imageUrl}")`

const Root = styled.div`
  height: 100%;
  position: relative;
  width: auto;
  height: auto;
  aspect-ratio: calc(393 / 264);
`

const imageCss = css`
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
`

const animationBaseCss = css`
  animation-duration: 0.5s;
  animation-timing-function: ease-in-out;
  animation-fill-mode: both;
  animation-name: ${contentShow};
`

const Bg = styled.div`
  position: absolute;
  inset: 0;

  background: ${url(BG_GRAY)};
  ${imageCss}
`

const ShieldAnimated = styled.div`
  position: absolute;
  inset: 0;

  background: ${url(SHIELD)};
  ${imageCss}
  ${animationBaseCss}
`

const WhiteShieldAnimated = styled.div`
  position: absolute;
  inset: 0;

  background: ${url(WHITE_SHIELD)};
  ${imageCss}
  ${animationBaseCss}
  animation-delay: 0.3s;
`

const WhiteHighlightAnimated = styled.div`
  position: absolute;
  inset: 0;

  background: ${url(SMALL_HIGHLIGHT_SHIELD)};
  ${imageCss}
  ${animationBaseCss}
  animation-delay: 0.3s;
`

const SmallShieldAnimated = styled.div`
  position: absolute;
  inset: 0;

  background: ${url(SMALL_SHIELD)};
  ${imageCss}
  ${animationBaseCss}
  animation-delay: 0.5s;
`
